import { render, staticRenderFns } from "./NotificationsCount.vue?vue&type=template&id=04b6f455&"
import script from "./NotificationsCount.vue?vue&type=script&lang=js&"
export * from "./NotificationsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports